import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Login } from '../core/auth/auth.actions';
import { AuthService } from '../core/auth/auth.service';
import { AppState } from '../core/core.state';
import { NotificationService } from '../core/notifications/notification.service';



/**
 * Login component
 */
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    userData$: Observable<any>;
    isAuthenticated$: Observable<boolean>;
    /**
     * Class constructor
     * @param router Router service
     * @param authService Authorization service
     */
    constructor(
        public authService: AuthService,
        // public oauthService: OAuthService,
        private router: Router,
        private notificationService: NotificationService,
        private store: Store<AppState>) {
    }

    ngOnInit(): void {
        // this.isAuthenticated$ = this.store.pipe(select(selectIsAuthenticated));

        this.userData$ = this.authService.userData;
        this.isAuthenticated$ = this.authService.signedIn;
    }

    /**
     * Perform user login
     */
    public async login() {
        this.store.dispatch(new Login());
    }

    forceRefreshSession() {
        this.authService.refresh().subscribe((data) => {
            // console.log('Refresh completed');
        });
    }

    getExp(data: number) {
        return new Date(data * 1000);
    }
}
